import { render, staticRenderFns } from "./LanguageCertificateSave.vue?vue&type=template&id=627d5439&"
import script from "./LanguageCertificateSave.vue?vue&type=script&lang=js&"
export * from "./LanguageCertificateSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports